<script>
import {ref} from "vue";
import LoadingPage from "@/components/assetComponents/LoadingPage.vue";
import FreeWorld from "@/assets/js/FreeWorld";
import {useRoute} from "vue-router";
import Swals from "@/assets/js/Swals";
import $ from "jquery";
import StarRating from 'vue-star-rating'
import {useStore} from "vuex";
import router from "@/router";
import useClipboard from "vue-clipboard3";

export default {
  name: "DetailsWorker",
  components: {LoadingPage , StarRating},
  setup() {
    let store = ref(useStore())

    let loading = ref(false)
    let dialog = ref(false)

    let id = useRoute().params.id
    let details = ref(null)

    let mark = ref(false)
    let rated = ref(0)

    function get_details() {
      loading.value = true
      FreeWorld.Heisenberg({worker_id: id}, 'show_worker', true).then((res) => {

        loading.value = false
        details.value = res.data
        rated.value = details.value.rated
        if (details.value.marked === 1) mark.value = true

      }).catch((res) => {
        loading.value = false
        Swals.Catch(res, get_details)
      })
    }
    get_details()

    function marked() {
      let data = {
        action: 'add_mark',
        second_id: details.value.id,
        type: 'worker',
      }

      $("#mark").addClass('pe-none')

      mark.value = !mark.value
      FreeWorld.Heisenberg(data, 'mark', true).then((res) => {
        if (res.data.status !== 'ok') mark.value = !mark.value
        $("#mark").removeClass('pe-none')
      }).catch((res) => {
        mark.value = !mark.value
        $("#mark").removeClass('pe-none')
        Swals.Catch(res, marked)
      })
    }

    function open_dialog() {
      let div_dialog = $('#dialog')

          if (dialog.value) {
            div_dialog.removeClass('animate__fadeIn').addClass('animate__fadeOut')
            setTimeout(() => {
              dialog.value = false
              rated.value = details.value.rated
            }, 700)
          } else {
            div_dialog.removeClass('animate__fadeOut').addClass('animate__fadeIn')
            dialog.value = true
          }
    }

    function add_rate() {

      if (details.value.rated !== 0){Swals.Warning('شما قبلا به ' + details.value.name + ' امتیاز داده اید!');return false}

      loading.value = true
      FreeWorld.Heisenberg({worker_id:details.value.id , rate:rated.value} , 'add_rate' , true).then((res)=>{
        loading.value = false
        if (res.data.status === 'ok'){
          Swals.Done('امتیاز شما با موفقیت ثبت شد')
          get_details()
        }else if (res.data.event === 'user rated in before') {
          Swals.Warning('شما قبلا به ' + details.value.name + ' امتیاز داده اید!')
        }else {
          Swals.Fault('متاسفانه امتیاز شما ثبت نشد!')
        }

          dialog.value = false
      }).catch((res)=>{
        loading.value = false
        Swals.Catch(res , add_rate)
      })
    }

    const {toClipboard} = useClipboard()
    async function call_worker() {
      await Swals.Dialog(details.value.phone , null, 'کپی کردن',).then(async (res) => {
        if (res.isConfirmed) {
          try {
            await toClipboard(details.value.phone)
            Swals.Done('شماره با موفقیت کپی شد');
          } catch (e) {
            Swals.Fault('متاسفانه شماره کپی نشد!');
          }
        }
      });
    }
    function chat_worker() {
      let data = ref({
        receiver_id: details.value.id,
        pic: details.value.pic,
        chat_info: details.value.name,
      })


      store.value.commit('set_chat' , data.value)
      router.push({name:'ChatsPage', params:{type:'profile_worker'}})
    }

    function report_worker() {
      Swals.Question(`آیا پروفایل ${details.value.name} را گزارش میدهید؟` , 'گزارش دادن').then((res)=>{
        if (res.isConfirmed){
          loading.value = true

          setTimeout(()=>{
            loading.value = false
            Swals.Done('گزارش شما ثبت شد')
          },1000)
        }
      })
    }


    return {
      loading,
      dialog,
      details,
      marked,
      mark,
      rated,
      add_rate,
      open_dialog,
      call_worker,
      store,
      chat_worker,
      report_worker,
    }
  }
}
</script>

<template>

  <LoadingPage v-if="loading"></LoadingPage>
  <div v-if="dialog" @click="open_dialog" class="bg_dialog"></div>
  <div v-if="dialog" id="dialog" class="animate__animated animate__fadeIn dialog px-3">
    <div class="bg-white rounded-4 p-3">
      <div class="d-flex justify-content-end mb-2">
        <img @click="open_dialog" class="icon-size-4" src="../assets/img/icon-closeBgColor.svg" alt="">
      </div>

      <p class="font-5 text-color text-center mb-3">امتیاز شما به {{ details.name }} چند ستاره است؟</p>

      <star-rating dir="ltr" v-model:rating="rated" :show-rating="false" :star-size="45" class="justify-content-around"></star-rating>

      <div class="d-flex justify-content-center mt-4">
        <p @click="add_rate" class="bg-color-liner p-3 rounded-pill text-white font-bold w-35 text-center">ثبت</p>
      </div>
    </div>
  </div>

  <div id="main" :class="loading ? 'activeClass':''" class="bg-color-liner">
    <div style="height: 5rem" class="d-flex align-items-center justify-content-between p-4">
      <div class="d-flex align-items-center">
      <img onclick="window.history.back()" class="icon-size-1 rounded-pill ms-3" src="../assets/img/icon-back.svg" alt="">

      <p v-if="details !== null" class="text-white font-bold font-4">{{ details.name }}</p>
      </div>

      <img @click="report_worker" src="../assets/img/icon-block-user.svg" class="icon-size-3" alt="">
    </div>

    <div id="chile-main" class="bg-main rounded-top-5 p-3 pt-4">
      <div v-if="details !== null" class="shadow-custom rounded-4 p-3">
        <div class="d-flex justify-content-between">
          <div class="profile">
            <img v-if="details.pic === null" class="profile" src="../assets/img/defult-profile.svg" alt="">
            <img v-else class="profile" :src="details.pic" alt="">
          </div>

          <div class="w-75 d-flex flex-column justify-content-around">
            <div class="overflow-hidden">
              <p class="font-4 font-bold text-color">{{ details.name }}</p>
            </div>

            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center w-60 justify-content-around">
                <a :href="'http://maps.google.com/maps?z=20&t=m&q=loc:'+ details.lat + '+' + details.lang" class="">
                  <img class="icon-size-4" src="../assets/img/icon-plaseBgColor.svg" alt="">
                </a>
                <img v-if="mark" @click="marked" id="mark" class="icon-size-4" src="../assets/img/icon-markBgColor-A.svg" alt="">
                <img v-else id="mark" @click="marked" class="icon-size-4" src="../assets/img/icon-markBgColor-NA.svg" alt="">
                <img @click="chat_worker" class="icon-size-4" src="../assets/img/icon-chatBgColor.svg" alt="">
                <img @click="call_worker" class="icon-size-4" src="../assets/img/icon-phoneBgColor.svg" alt="">
              </div>

              <div @click="open_dialog" class="bg-custom rounded-pill shadow-custom p-2 d-flex align-items-center">
                <img class="icon-size-1 ms-1" src="../assets/img/icon-star.svg" alt="">
                <p class="font-5 text-color">{{ details.rate }} از 5</p>
              </div>
            </div>
          </div>
        </div>

        <hr>

        <p class="font-5">{{ details.bio }}</p>

        <hr>

        <div class="">
          <p class="font-5 text-color mb-2">آدرس محل کار : {{ details.address }}</p>
          <p class="font-5 text-color mb-2">تلفن همراه : {{ details.phone }}</p>
          <p v-if="details.phone2 !== null" class="font-5 text-color">تلفن محل کار : {{ details.phone2 }}</p>
        </div>
      </div>
    </div>
  </div>

</template>

<style scoped>
.profile {
  width: 6rem;
  height: 6rem;
  border-radius: 50%;
}
</style>